import { render, staticRenderFns } from "./TripEdit.vue?vue&type=template&id=0f5a61c5&scoped=true&"
import script from "./TripEdit.vue?vue&type=script&lang=js&"
export * from "./TripEdit.vue?vue&type=script&lang=js&"
import style0 from "./TripEdit.vue?vue&type=style&index=0&id=0f5a61c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5a61c5",
  null
  
)

export default component.exports